import { GlobalConfigType } from 'actions/global.config.type'
// import { borrowerDocCategory } from 'pages/Borrower/ManageBorrowers/constants'
import { store } from 'reducers'
import { getOptionValues } from 'utils/general'

export const actionConditionNos = {
  SSN: 1050,
  FLOOD_DETERMINATION: 1029,
}

export enum ConditionExceptionStatus {
  None = 0,
  ApprovedByLender = 1,
  ApprovedByInvestor = 2,
  DeniedByLender = 3,
  DeniedByInvestor = 4,
  WaivedNotRequired = 5,
  PendingWithLender = 6,
  PendingWithInvestor = 7,
}

export const conditionExceptionStatus: Record<ConditionExceptionStatus, string> = {
  [ConditionExceptionStatus.None]: '',
  [ConditionExceptionStatus.ApprovedByLender]: 'Approved By Lender',
  [ConditionExceptionStatus.ApprovedByInvestor]: 'Approved By Investor',
  [ConditionExceptionStatus.DeniedByLender]: 'Denied By Lender',
  [ConditionExceptionStatus.DeniedByInvestor]: 'Denied By Investor',
  [ConditionExceptionStatus.WaivedNotRequired]: 'Waived - Not Required',
  [ConditionExceptionStatus.PendingWithLender]: 'Pending With Lender',
  [ConditionExceptionStatus.PendingWithInvestor]: 'Pending With Investor',
}

export const docStatus = [
  'Not Reviewed',
  'Approved',
  'Inactive',
  'Incomplete',
  'Missing Pages',
  'Unacceptable',
  'Duplicate',
  'Illegible',
  'Reviewed',
  'AI Reviewed',
  'AI Approved',
]

export const docCategory = () => {
  const { globalConfigReducer } = store.getState()
  return getOptionValues(globalConfigReducer[GlobalConfigType.DocumentCategory])
}

/**
 * The category dropdown for a document that is already filed under one. A document can carry a
 * category the dropdown no longer offers - retired by an admin, or still on the lettering it was
 * filed under before the categories were tidied up - and a native select shows an unmatched value
 * as an empty cell that the next save would silently overwrite. So resolve the stored value to the
 * configured spelling when the only difference is case, and keep it as an extra option when it
 * matches nothing at all.
 */
export const docCategoryFor = (current?: string, options: string[] = docCategory()) => {
  const value = current || ''
  if (!value) return { options, value }
  const matched = options.find((option) => option.toLowerCase() === value.toLowerCase())
  return matched ? { options, value: matched } : { options: [...options, value], value }
}

export const LoanProcessRushPaymentRequestTypeTitles: Record<string, string> = {
  entire: 'Rush File Review Request',
  appraisal: 'Transferred Appraisal Review Request',
  both: 'Rush Review and Transferred Appraisal Review Request',
  diligence: 'Commitment Fee',
  creditReport: 'Credit Report Fee',
  commitmentCreditReport: 'Commitment and Credit Report Fee',
  custom: '',
}

export const requestedToParties: Record<string, string> = {
  Borrower: 'Borrower',
  'Title Company': 'Title Agent',
  'Hazard Insurance Company': 'Insurance Agent',
  'Escrow Company': 'Escrow Agent',
  Appraiser: 'Appraiser',
  Broker: 'Third Party Originator',
}

// Loan.Submission.Condition.Notes.Add
// export const isOriginatorAccountType = (accountType: AccountType) => {
//   return [
//     AccountType.ADMIN,
//     AccountType.BROKER,
//     AccountType.CORRESPONDENT,
//     AccountType.TABLEFUNDER,
//     AccountType.LOAN_OFFICER,
//     AccountType.BRANCH,
//     AccountType.LOAN_PROCESSOR,
//     AccountType.LOAN_OFFICER_RETAIL,
//     AccountType.LOAN_PROCESSOR_RETAIL,
//   ].includes(accountType)
// }
